import React, {Component} from 'react';
import PartOne from './join/part-one';
import PartTwo from './join/part-two';
import PartThree from './join/part-three';
import SignIn from './join/sign-in';
import Loading from '../loading';
import ForgotPassword from './join/forgot-password';
import {CONFIG, I18N} from '../../globals/config';

export const LOGIN_STEP  = 'login';
export const JOIN_STEP   = 'join';
export const FORGOT_STEP = 'forgot';

const api = CONFIG.api + 'join_modal/';

class JoinModal extends Component {

	constructor( props ){
		super( props );

		this.state = {
			first_name : "",
			last_name : "",
			email : "",
			failed : [],
			error_message : "",
			loading : false,
			step : ( !props.open_with_login ) ? JOIN_STEP : LOGIN_STEP
		};

		_.bindAll( this, 'change_form_field_value', 'changeStep', '_validate_fields', '_create_user' );
	}

	componentWillMount(){
		this._change_modal_title( this.state.step );
	}


	_change_modal_title( $step ){
		if( $step == LOGIN_STEP ){
			this.props.change_title( I18N.sign_in );
		} else if( $step == 2 ){
			this.props.change_title( I18N.welcome + ' ' + this.state.first_name );
		} else if( $step == 3 ){
			this.props.change_title( I18N.subscriptions.ready_to_go );
		} else {
			this.props.change_title( I18N.join_now );
		}
	}


	change_form_field_value( event ){
		this.state[event.target.name] = event.target.value;
		this.setState( this.state );
	}

	changeStep( event ){
		let $step = $( event.target ).data( 'step' );

		this._change_modal_title( $step );

		if( this.state.step == JOIN_STEP && $step != LOGIN_STEP ){
			if( this._validate_fields() ){
				this._create_user();
			}
		} else {
			this.setState( {
				step : $step
			} );
		}

	}

	_validate_fields(){
		let $failed = [];
		_.each( this.props.required, function( $field ){
			if( "" == this.state[$field] ){
				$failed.push( $field );
			}
		}.bind( this ) );

		this.setState( {
			failed : $failed
		} );

		return $failed.length < 1;
	}


	_create_user(){
		var data    = this.state;
		data.method = 'create_user';
		if( !_.isEmpty( this.props.subscription ) ){
			data.subscription = this.props.subscription;
		}

		this.setState( {
			loading : true
		} );

		$.post( api, data, function( response ){
			if( _.isObject( response ) ){
				if( response.success == false ){
					this.setState( {
						error_message : response.data,
						loading : false
					} );
				} else {
					if( _.isEmpty( this.props.open_with_login ) ){
						this._change_modal_title( 2 );
						this.setState( {
							step : 2,
							loading : false
						} );
					} else {
						window.location.reload();
					}
				}
			} else {
				this.setState( {
					error_message : I18N.errors.something_wrong,
					loading : false
				} )
			}
		}.bind( this ) );
	}


	render(){
		let content = "";
		if( this.state.loading ){
			content = ( <Loading /> );
		} else {
			if( this.state.step === JOIN_STEP ){
				content = <PartOne {...this.state} onChange={this.change_form_field_value} changeStep={this.changeStep}/>;
			} else if( this.state.step === 2 ){
				content = <PartTwo  {...this.state} onChange={this.change_form_field_value} changeStep={this.changeStep} {...this.props}/>;
			} else if( this.state.step === 3 ){
				content =
					<PartThree {...this.state} onChange={this.change_form_field_value} changeStep={this.changeStep} {...this.props}/>;
			} else if( this.state.step === LOGIN_STEP ){
				content =
					<SignIn {...this.props} {...this.state} onChange={this.change_form_field_value} changeStep={this.changeStep}/>;
			} else if( this.state.step === FORGOT_STEP ){
				content = <ForgotPassword {...this.state} changeStep={this.changeStep} />;
			}
		}


		return (
			<div className="join-modal">
				<div className={'step-' + this.state.step}>
					{content}
				</div>
			</div>
		)
	}

}

JoinModal.defaultProps = {
	required : ['email', 'first_name', 'last_name']
};


export default JoinModal;


// WEBPACK FOOTER //
// ./src/components/modals/join-modal.js